<template>
  <v-card min-width="400">
    <v-card-title>Add Notes </v-card-title>
    <v-list class="v-card-overlay-jobs">
      <v-list-item
        density="compact"
        :title="name"
        prepend-icon="mdi-account"
      ></v-list-item>
      <v-list-item
        density="compact"
        :title="customer.phone"
        prepend-icon="mdi-phone"
      ></v-list-item>
      <v-list-item
        density="compact"
        :title="customer.email"
        prepend-icon="mdi-email-outline"
      ></v-list-item>
      <v-list-item prepend-icon="mdi-face-agent">
        <div v-if="eventServiceList">
          <v-chip
            v-for="(ser, index) in eventServiceList"
            :key="index"
            size="x-small"
            :class="`bg-${getTitleColor(ser)}`"
          >
            {{ ser.description }}
          </v-chip>
        </div>
        <div v-if="!eventServiceList" style="max-width: 300px">
          <v-select
            v-model="apptServices"
            :items="servicesList"
            item-title="description"
            item-value="id"
            item-color="getTitleColor(description)"
            chips
            multiple
          ></v-select>
        </div>
      </v-list-item>
    </v-list>
    <div>
      <v-textarea v-model="client_note" label="Note"></v-textarea>
    </div>
    <v-card-actions>
      <v-btn
        v-if="addNoteButton"
        color="light-blue"
        variant="flat"
        :loading="processingAddNote"
        @click="addNote(event)"
        >Add Note</v-btn
      >
      <div v-if="!addNoteButton" style="none">
        <v-btn color="red" variant="flat" min-width="25" @click="closeAddNote"
          >Close</v-btn
        >
        <v-btn color="green" icon="mdi-check-circle"></v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getTitleColor } from "../../libs/util";
import { useAppointmentStore } from "../../stores/appointmentsStore";
import { servicesList } from "../../libs/options";
import axios from "axios";
export default {
  name: "SearchAddNotes",
  props: {
    event: {
      type: Object,
      default: () => {},
    },
    customerId: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const appointmentStore = useAppointmentStore();
    return { getTitleColor, appointmentStore, servicesList };
  },
  data() {
    return {
      processingAddNote: false,
      addNoteButton: true,
      client_note: "",
      apiURL: import.meta.env.VITE_API_URL,
      customer: {},
      appointment_services: [],
      apptServices: [],
    };
  },

  computed: {
    name() {
      return this.customer.firstname + " " + this.customer.lastname;
    },
    eventServiceList() {
      if (typeof this.event === "undefined") return null;
      const services = Object.assign([], this.event.services);
      services.sort((a, b) => a.id - b.id);
      return services;
    },
  },
  created() {
    // added the right check
    if (
      this.customerId !== null &&
      this.appointmentStore.from_dropdown == true
    ) {
      axios.get(this.apiURL + "customers/" + this.customerId).then((res) => {
        this.customer = res.data.data;
        this.appointmentStore.from_dropdown = false;
      });
    } else if (typeof this.event.customer !== "undefined") {
      this.customer = this.event.customer;
    }
  },
  methods: {
    async addNote() {
      this.processingAddNote = true;
      await axios
        .post(this.apiURL + "notes", {
          customer: {
            firstname: this.customer.firstname,
            lastname: this.customer.lastname,
            email: this.customer.email,
            phone: this.customer.phone,
          },
          salon_id: this.page_title(),
          salon_client_id: this.customer.id,
          salon_appointment_id: this.event ? this.event.id : 0,
          salon_appointment_service_id: this.event
            ? this.event.service_id
            : this.apptServices,
          client_note: this.client_note,
        })
        .then((res) => {
          if (typeof res.data.id !== "undefined") {
            this.processingAddNote = false;
            this.addNoteButton = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      setTimeout(() => {
        this.processingAddNote = false;
        this.addNoteButton = false;
      }, 1000);
    },
    closeAddNote() {
      this.appointmentStore.$patch({
        barSearch: {
          isShowSearch: false,
          isNotesSearch: false,
          notesEventId: null,
        },
      });
    },
    page_title() {
      let indi = document.title.search("([0-9]|[1-9])");
      return document.title
        .slice(indi + 2)
        .replaceAll("_", " ")
        .trim();
    },
  },
};
</script>
